module.exports = __webpack_public_path__ + "static/media/wheelPointer.43ee18dc.svg";